import React from 'react';
import Select, { MultiValue, SingleValue, OnChangeValue } from 'react-select';
import type { UseFormRegisterReturn } from 'react-hook-form';

type Option = {
  label: string;
  value: string;
};

interface SelectFilterProps {
  label: string;
  registerReturn: UseFormRegisterReturn;
  isMulti: boolean;
  isClearable?: boolean;
  options: Option[];
  value: MultiValue<Option> | SingleValue<Option> | null | undefined;
  placeholder?: string;
  showTick?: boolean;
  onChange: (selected: OnChangeValue<Option, boolean>) => void;
  onClear: () => void;
  selectClassName?: string;
}

const SelectFilter: React.FC<SelectFilterProps> = ({
  label,
  registerReturn,
  isMulti,
  isClearable,
  options,
  value,
  placeholder,
  selectClassName = 'divSelect',
  showTick,
  onChange,
  onClear,
}) => {
  // Custom styles to ensure menu appears above sticky headers
  const customStyles = {
    menu: (provided: any) => ({
      ...provided,
      zIndex: 1060,
    }),
    menuPortal: (provided: any) => ({
      ...provided,
      zIndex: 1060,
    }),
  };

  return (
    <div className="filterItem">
      <div>
        <label className="txtDropdownLabel">{label}</label>
      </div>

      <div className={selectClassName}>
        <Select
          {...registerReturn}
          isMulti={isMulti}
          isClearable={isClearable}
          options={options}
          value={value as any}
          placeholder={placeholder}
          onChange={onChange}
          styles={customStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
        {/* showTick and menuSize are non-standard props in react-select; retained in API but not forwarded */}
        {/* clear handled via onClear prop at parent level */}
      </div>
    </div>
  );
};

export default SelectFilter;
